import { SelectInput } from 'shared/components';
import { useCommodityList } from 'shared/queries';
import { toTitleCase } from 'shared/utility';

export function CommoditiesDropdown() {
  const { commodities } = useCommodityList();
  return (
    <SelectInput
      name='commodities'
      label='Assigned Commodities'
      options={commodities || []}
      getOptionLabel={option => toTitleCase(option.name)}
      getOptionSelected={(option, value) => option.id === value.id}
      multiple
      filterSelectedOptions
      disableCloseOnSelect
      loading={!Boolean(commodities)}
      rules={{ required: { message: 'Commodities must be assigned', value: true } }}
    />
  );
}
